import { css } from '@emotion/react';
import tw from 'twin.macro';

export const stylesBase = css`
  :root {
    --color-light: 212 212 212; // #D4D4D4
    --color-medium-light: 147 148 150; // #787878
    --color-medium: 45 45 45; // #2D2D2D
    --color-medium-dark: 11 11 11; // #0B0B0B
    --color-dark: 27 27 27; // #1B1B1B

    --color-brand: 102 204 34; // #66CC22
    --color-info: 136 173 216; // #88ADD8
    --color-success: 102 204 34; // #66CC22
    --color-warning: 244 186 62; // #F4BA3E
    --color-danger: 215 75 75; // #D64B4B
    --color-ads: 85 85 85; // #555555

    --toastify-text-color: #111111;

    --toastify-color-default: #d4d4d4;
    --toastify-color-info: #88add8;
    --toastify-color-success: #66cc22;
    --toastify-color-warning: #f4ba3e;
    --toastify-color-error: #d64b4b;
  }

  .dark {
    --theme-hex: #1b1b1b;
    --text-base-color: var(--color-light);
    --color-header: var(--color-dark);
    --color-icons: var(--color-medium-light);
    --color-primary: var(--color-dark);
    --color-secondary: var(--color-medium);
    --color-input-front: var(--color-light);
    --color-input-back: var(--color-medium-dark);
  }

  .light {
    --theme-hex: #fafafa;
    --theme: 250 250 250; // #FAFAFA
    --text-base-color: var(--color-medium);
    --color-header: var(--color-dark);
    --color-primary: var(--theme);
    --color-secondary: var(--color-medium);
    --color-icons: var(--color-medium-light);
    --color-input-front: var(--color-medium);
    --color-input-back: var(--color-light);
  }

  .dumpert {
    --color-brand: 247 247 247; // #f7f7f7
    --color-header: 86 175 36; // #56AF24
    --text-base-color: 27 27 27; // #1B1B1B
    --color-primary: 86 175 36; // #56AF24
    --color-secondary: 70 143 30; // #468f1E
    --color-input-back: 57 101 32; // #396520
    --color-icons: 212 212 212; // #D4D4D4
  }

  body {
    background-color: var(--theme-hex);
  }

  :is(p, small, div) + :is(h1, h2, h3, h4, h5, h6) {
    margin-top: 2rem;
  }

  /* Chrome, Safari and Opera */
  .no-scrollbar::-webkit-scrollbar {
    display: none;
  }

  .no-scrollbar {
    -ms-overflow-style: none; /* IE and Edge */
    scrollbar-width: none; /* Firefox */
  }

  p a,
  [data-description='detail'] a {
    ${tw`text-brand`}
  }

  ::selection {
    ${tw`text-primary bg-brand`}
  }
`;
